const session_expired = {
    title: 'Sessão expirada',
    subtitle: 'Sua sessão pode ter expirado e você foi desconectado. Clique no botão abaixo para fazer login no Admin Console novamente.',
    button: 'Entrar novamente',
};
export default Object.freeze(session_expired);
